module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Rc3RBJ/tc-custom/9781460331842.jpg?1704827704887",
      "alt": "This image is the cover for the book District, Brody Law"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("District, Brody Law\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("IN THE CITY BY THE BAY IT'LL TAKE TWO EXPERIENCED FBI AGENTS TO BRING AN END TO A SERIAL KILLER'S REIGN. ")]), _c('br'), _c('br'), _vm._v("The quicker Special Agent Christina Sandoval brings a serial killer to justice, the sooner she can get back to her daughter. Reason enough for the FBI to send her a partnerwho also happens to be her ex-fiancé, Eric Brody.  "), _c('br'), _c('br'), _vm._v("While Eric's own kidnapping as a child has left him with a sense of justice that never failed, his relationship with Christina had. Now the deeper they dig into the current case, the more personal things get. Trying to capture an elusive killer who seems to know more about Christina than Brody ever did, they'll both need to stop holding back. Or fall victim to this private war, waged without boundaries\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carol Ericson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carol Ericson lives in southern California, home of state-of–the-art cosmetic surgery, wild freeway chases, and a million amazing stories. These stories, along with hordes of virile men and feisty women clamor for release from Carol’s head until she sets them free to fulfill their destinies and her readers’ fantasies. To find out more about Carol and her current books, please visit her website at www.carolericson.com, “where romance flirts with danger.”")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0